import { Component } from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Unhandled UI error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-6" data-testid="error-boundary">
          <div className="max-w-md text-center space-y-5">
            <div className="mx-auto h-14 w-14 rounded-2xl bg-destructive/15 text-destructive flex items-center justify-center">
              <AlertTriangle className="h-7 w-7" />
            </div>
            <div className="space-y-2">
              <h1 className="font-display text-2xl font-bold">Something went wrong</h1>
              <p className="text-sm text-muted-foreground">An unexpected error occurred while rendering this page. You can reload to continue.</p>
            </div>
            <Button onClick={() => window.location.reload()} className="rounded-lg" data-testid="error-reload-btn">Reload page</Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
